module.exports = __webpack_public_path__ + "img/destinations-europe.0ac0e12a.webp";